
module Meevo.Plugins.AppointmentBook {
class MessageController {
    private modal;
    private globals;
    section: string;
    showOk: boolean;
    showCancel: boolean;
    showYes: boolean;
    showContinue: boolean;
    showNo: boolean;
    message: string;
    messageClass: string;
    actions: any;
    
    static $inject = ['appointmentBookActionsService','appointmentBookGlobalsService', 'appointmentBookModalService', 'message', 'config', '$sce'];

    constructor(actions,globals, modal, message, private config, private $sce) {
        this.modal = modal;
        this.globals = globals;
        this.actions = actions;
        
        if (this.config == undefined) {
            this.config = {};
        }

        if (this.config.buttonsType == undefined) {
            this.config.buttonsType = Meevo.Model.ButtonTypeEnum.Ok;
        }
        if (this.config.hidePopupOnButtonClick == undefined) {
            this.config.hidePopupOnButtonClick = true;
        }

        this.messageClass = "normal";
        if (this.config.messageClass != undefined) {
            this.messageClass = this.config.messageClass;
        }

        if (this.config.customTemplateId != undefined) {
            this.section = this.config.customTemplateId;
        } 

        switch (this.config.buttonsType) {
            case Meevo.Model.ButtonTypeEnum.Ok:
                this.showOk = true;
                break;
            case Meevo.Model.ButtonTypeEnum.OkCancel:
                this.showOk = true;
                this.showCancel = true;
                break;
            case Meevo.Model.ButtonTypeEnum.YesNo:
                this.showYes = true;
                this.showNo = true;
                break;
            case Meevo.Model.ButtonTypeEnum.ContinueCancel:
                this.showContinue = true;
                this.showCancel = true;
        }

        if (this.config.showAsHtml) {
            this.message = this.$sce.trustAsHtml(message);
        }
        else {
            this.message = message;
        }
    }

    messageDialogOk() {
        if (this.config.hidePopupOnButtonClick) {
            this.modal.hideModal({
                result: Meevo.Model.MessageBoxButtonResult.Ok,
                callback: this.config.callback,
                callbackParam: this.config.callbackParam
            });
        }
    }
    messageDialogCancel() {
        this.modal.hideModal({
            result: Meevo.Model.MessageBoxButtonResult.Cancel,
            callback: this.config.callback,
            callbackParam: this.config.callbackParam
        });
    }
    messageDialogYes() {
        this.modal.hideModal({
            result: Meevo.Model.MessageBoxButtonResult.Yes,
            callback: this.config.callback,
            callbackParam: this.config.callbackParam
        });
    }
    messageDialogNo() {
        this.modal.hideModal({
            result: Meevo.Model.MessageBoxButtonResult.No,
            callback: this.config.callback,
            callbackParam: this.config.callbackParam
        });
    }
}

    angular.module("ApptBookApp")
        .controller("meevo.plugins.appointmentBook.MessageController", MessageController);
}